import { Location } from "../organisation/Location"
import { Transactor, buildTransactorFromDetail } from "./Transactor"
import { User } from "./User"

// The gateway returns a flat transactor_id; Hasura returned a nested object.
function buildTransactor(p: any): Transactor | null {
    if (p.transactor) {
        return buildTransactorFromDetail(p.transactor)
    }
    return p.transactor_id ? new Transactor(p.transactor_id) : null
}

export class Person {
    id: number
    firstname: string
    lastname: string
    nickname?: string
    user?: User
    location?: Location
    transactor?: Transactor
    fullname?: string
    email?: string
    phone_number?: string
    avatar_uri?: string

    constructor(p: any) {
        this.id = p.id
        this.firstname = p.firstname
        this.lastname = p.lastname
        this.nickname = p.nickname
        this.user = p.user
        this.location = p.location
        this.transactor = p.transactor
        this.fullname = p.fullname
        this.email = p.email
        this.phone_number = p.phone_number
        this.avatar_uri = p.avatar_uri
    }

    getFullName(): string {
        if (this.fullname) {
            return this.fullname
        }
        let name: string = this.firstname
        if (this.lastname) {
            name = `${name} ${this.lastname}`
        }
        return name
    }

    static buildCRMPerson(p: any): Person {
        return new Person({
            ...p,
            firstname: p.first_name,
            lastname: p.last_name
        })
    }

    static build(p: any): Person {
        return new Person({
            id: p.id,
            firstname: p.firstname ?? p.first_name,
            lastname: p.lastname ?? p.last_name,
            nickname: p.nickname,
            user: p.user ? User.build(p.user) : null,
            location: p.location ? Location.build(p.location) : null,
            transactor: buildTransactor(p),
            email: p.email,
            phone_number: p.phone_number,
            avatar_uri: p.avatar_uri ?? p.user?.avatar_uri})
    }
}